import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getImportInvoicePreview, {
  ImportInvoicePreviewResponse,
} from "../http/getImportInvoicePreview";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UseImportInvoicePreviewParams {
  siteId: string;
  month: string;
  enabled?: boolean;
}

export const useImportInvoicePreview = ({
  siteId,
  month,
  enabled,
}: UseImportInvoicePreviewParams) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchImportInvoicePreview: UseQueryResult<
    ImportInvoicePreviewResponse,
    unknown
  > = useQuery(
    ["site", siteId, "import_invoice_preview", month],
    async () => {
      return getImportInvoicePreview(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        month
      );
    },
    {
      enabled: (enabled ?? true) && !!month,
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    fetchImportInvoicePreview,
  };
};
